import axios from 'axios';
import { Capacitor } from '@capacitor/core';
import { loginUser, logoutUser, selectLanguage } from '../features/userSlice';
export const getEvents = (reptileId) => api.get(`/reptile/events/${reptileId}`);
export const postEvent = (event) => api.post('/reptile/events', event);
export const deleteEvent = (eventId) => api.delete(`/reptile/events/${eventId}`);
export const createStripeCheckout = (plan, userId, interval = 'monthly') => {
    return api.post('/stripe/create-checkout-session', { plan, interval });
};
export const manageStripeSubscription = (newPlan, userId, interval = 'monthly') => {
    return api.post('/stripe/manage-subscription', { newPlan, interval });
};
export const cancelStripeSubscription = (userId) => api.post('/stripe/cancel-subscription', { userId });
export const createStripePortalSession = (userId) => api.post('/stripe/create-portal-session', { userId });
export const getAccessibleWorkspaces = () => api.get('/user/accessible-workspaces');
export const addDelegate = (email, role) => api.post('/user/delegates', { email, role });
export const removeDelegate = (delegateId) => api.delete(`/user/delegates/${delegateId}`);
export const getCalendarEvents = (reptileId) =>
    api.get(`/calendar${reptileId ? `?reptileId=${reptileId}` : ""}`);
// Aggiungi insieme a addDelegate e removeDelegate
export const getDelegates = () => api.get('/user/delegates');
export const createCustomCalendarEvent = (event) =>
    api.post("/calendar/custom", event);

export const deleteCustomCalendarEvent = (eventId) =>
    api.delete(`/calendar/custom/${eventId}`);
export const hatchBreeding = async (breedingId, data) => {
    const response = await api.post(`/breeding/${breedingId}/hatch`, data);
    return response.data;
};
let currentLanguage = navigator.language.split('-')[0] || 'it';
let reduxStore;
export const injectStore = (_store) => {
    reduxStore = _store;
};
export const setApiLanguage = (lang) => {
    currentLanguage = lang;
};
const isNative = Capacitor.isNativePlatform();
/**
 * Recupera i rettili pubblici per lo shop.
 * @param {object} params - Oggetto per i filtri, es: { page: 1, species: 'python', morph: 'piebald', zona: 'milano' }
 */
export const getPublicReptiles = (params) => {
    return api.get('/shop/reptiles', { params });
};

/**
 * Recupera gli allevatori pubblici.
 * @param {object} params - Oggetto per i filtri, es: { page: 1 }
 */
export const getPublicBreeders = (params) => {
    return api.get('/shop/breeders', { params });
};

/**
 * Recupera il profilo pubblico di un singolo allevatore e i suoi rettili.
 * @param {string} userId - L'ID dell'utente allevatore
 */
export const getPublicBreederProfile = (userId) => {
    return api.get(`/shop/breeders/${userId}`);
};


const api = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
    withCredentials: !isNative,
});
function forceLogout() {
    reduxStore?.dispatch?.(logoutUser());
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('operateAsId');
    reduxStore?.dispatch?.({ type: 'persist/PURGE' });
    localStorage.removeItem('persist:root');
    localStorage.removeItem('persist:user');
    // niente più refreshToken in localStorage: vive nei cookie httpOnly
    const isOnLoginPage = window.location.pathname.startsWith('/login');
    if (!isOnLoginPage) {
        window.location.href = '/login';
    }
}

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        config.headers['Accept-Language'] = currentLanguage;
const operateAsId = localStorage.getItem('operateAsId');

    if (operateAsId && !config.url.includes('/user/accessible-workspaces')) {
            config.headers['X-Operate-As'] = operateAsId;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
let refreshPromise = null;

api.interceptors.response.use(

    response => response,
    async (error) => {
        const originalRequest = error.config;
        const status = error.response?.status;
        const isRefreshCall = originalRequest?.url?.includes('/v1/refresh-token');

        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            if (!refreshPromise) {
                const refreshConfig = {
                    withCredentials: !isNative
                };
                let refreshPayload = null;

             if (isNative) {
                    const appRefreshToken = localStorage.getItem('refreshToken');
                    if (!appRefreshToken) {
                        forceLogout();
                        return Promise.reject(error);
                    }
                    refreshPayload = { refreshToken: appRefreshToken };
                }

                refreshPromise = axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/v1/refresh-token`,
                    refreshPayload,
                    refreshConfig
                ).then(res => {
                    const newAT = res.data?.accessToken;
                    if (!newAT) throw new Error("No accessToken in refresh response");
                    localStorage.setItem('token', newAT);
                    if (isNative && res.data?.refreshToken) {
                        localStorage.setItem('refreshToken', res.data.refreshToken);
                    }
                    return newAT;
                }).finally(() => {
                    refreshPromise = null;
                });
            }

            try {
                const newToken = await refreshPromise;
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                return api(originalRequest);
            } catch {
                forceLogout();
                return Promise.reject(error);
            }
        }

        if (isRefreshCall && (status === 401 || status === 403)) {
            forceLogout();
        } return Promise.reject(error);
    }
);

export default api;
